import { render, staticRenderFns } from "./NoDataAvailable.vue?vue&type=template&id=fdd96bda"
import script from "./NoDataAvailable.vue?vue&type=script&lang=js"
export * from "./NoDataAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports